import { useEffect } from "react";
import { useLocation } from "react-router-dom";

/**
 * Riporta sempre la finestra in cima ogni volta che cambia route.
 * Va renderizzato una sola volta dentro <BrowserRouter>.
 */
export default function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: "instant" });
  }, [pathname]);

  return null;
}
